// #79 Stamp: who acted and how long ago, right-aligned in 12 px --text-3 (*Held by Marcus Bell · 2 days ago*). The age
// reads the frozen instant (useNow), never the clock; the absolute date and time are the tooltip of the <time>, which is
// a tab stop so the tooltip is reachable from the keyboard. An optional 18 px avatar leads.

import { Avatar } from "../core";
import { LABEL_TEMPLATES } from "../labels";
import { cx } from "../lib/cx";
import { useHs, type Hs } from "../lib/hs";
import { formatDateTime, relativeAge, toEpoch, type Instant } from "../lib/time";
import { Tooltip } from "../lib/Tooltip";
import { useNow } from "../lib/useNow";

export interface StampProps {
  /** The actor's name. */
  actor: string;
  at: Instant;
  /** The held form: *Held by {actor} · {age}*. */
  held?: boolean | undefined;
  /** Draws the 18 px avatar before the words. */
  avatar?: boolean | undefined;
  /** The avatar's hue key (an id). */
  hueKey?: string | undefined;
  hs?: Hs | undefined;
  className?: string | undefined;
}

export function Stamp({ actor, at, held, avatar, hueKey, hs, className }: StampProps) {
  const now = useNow();
  const hot = useHs(hs);
  const age = relativeAge(now, at);
  const iso = new Date(toEpoch(at)).toISOString();
  const time = (
    <Tooltip label={formatDateTime(at)}>
      <time className="mc-stamp-t" dateTime={iso} tabIndex={0} {...hot}>{age}</time>
    </Tooltip>
  );
  return (
    <span className={cx("mc-stamp", className)}>
      {avatar ? <Avatar name={actor} hueKey={hueKey} size={18} decorative /> : null}
      {held
        ? <span className="mc-stamp-w">{LABEL_TEMPLATES.heldBy({ actor, rel: "" }).replace(/\s·\s$/, "")}</span>
        : <span className="mc-stamp-w">{actor}</span>}
      <span aria-hidden="true">{" · "}</span>
      {time}
    </span>
  );
}
